import API_ROUTES from "../constants/api";
import { DEFAULT_ITEMS_PER_PAGE } from "../constants/common";
import HttpUtil from "../http-handler/http-util";

export default class DatapointSuppliersService {
  static getSuppliers(encodedUrlParam,period,pageNumber=0,pageSize = DEFAULT_ITEMS_PER_PAGE,key,sort,configType='') {
    var url = (API_ROUTES.DATAPOINTSSUPPLIER.ALLSUPPLIERLIST).replace("<encodedUrlParam>", encodedUrlParam)
    .replace("<period>", period)
    .replace("<pageNumber>", pageNumber)
    .replace("<pageSize>", pageSize)
    .replace("<key>", key)
    .replace("<sort>", sort)
    .replace(configType ? "<type>" : "&type=<type>", configType);
    return HttpUtil.get(url);
  }
}
